const GOAL_DIFFERENCE = 0.025;
const MAX_SIZE = 3000;
const MIN_SIZE = 800;
const WINDOW_SIZE = 2;

export function findLoop(buffer, solutionNumber, goal=GOAL_DIFFERENCE, minSize=MIN_SIZE) {
    let channel = buffer.getChannelData(0);

    let buf = window.api.create_buffer(channel.length);
    window.Module.HEAPF32.set(channel, buf >> 2);
    window.api.findLoop(buf, channel.length, solutionNumber, goal, minSize);
    const resultPointer = window.api.get_result_pointer();
    const resultView = new Uint16Array(window.Module.HEAP16.buffer, resultPointer, 2);
    console.log('resultView = ', resultView);
    if (resultView[0] == 0 && resultView[1] == 0) {
        return undefined;
    }
    let x = {
        start: resultView[0],
        end: resultView[1],
        difference: 1,
    };
    window.api.destroy_buffer(buf);
    return x;

    /*
    let zeroes = [];
    let count = 0;
    let minSolution = undefined;
    let minDifference = 1000;
    for (let i=0; i < channel.length; i++) {
        if (i % WINDOW_SIZE === 0) {
            try {
                let candidate = {start: i, end: i+minSize};
                let solution = improve(candidate, channel, goal);
                if (solution === undefined) {
                    continue;
                }
                console.log('count solution', count, solution);
                if (minDifference > solution.difference) {
                    minDifference = solution.difference;
                    minSolution = solution;
                }
                if (count === solutionNumber) {
                    return minSolution;
                }
                count++;
            } catch (e) {
            }
        }
    }
    */
}

function improve({start, end}, channel, goal, intermediateGoal=2) {
    let size = end - start;
    if (end >= channel.length || size > MAX_SIZE) {
        return undefined;
    }

    let sum = 0;
    for (let i=0; i < 50; i++) {
        sum += Math.pow(channel[start + i] - channel[end + i], 2);
    }

    let diff = Math.sqrt(sum);
    // console.log('difference', start, end, diff);
    if (diff <= goal) {
        return {start, end, difference: diff};
    }

    if (diff < intermediateGoal) {
        return improve({start: start, end: end + 1}, channel, goal, intermediateGoal - intermediateGoal / 100);
    }
}

function difference(a, b) {
    let sum = 0;
    for (let i in a) {
        sum += Math.pow(a[i] - b[i], 2);
    }
    return Math.sqrt(sum);
}

